module.exports = __webpack_public_path__ + "static/img/nongye.467c7250.png";